<template>
  <b-form-group
    id="fieldset-1"
    :description="description"
    :label="label" label-cols="3" 
    label-for="inp" label-size="sm"
    :invalid-feedback="invalidFeedback"
    :valid-feedback="validFeedback"
    :state="state"
  >
    <b-form-select :name="name" :multiple="multi"
      :value="value" id="inp"
      @input.native="$emit('input',$event.target.value)"
      :state="state" :options="options" size="sm">
    </b-form-select>
  </b-form-group>
</template>
<script>
export default {
  name: 'SelectList',
  props: ['multi', 'options', 'name', 'label','value', 'description','type', 'invalidFeedback', 'validFeedback', 'state']
}
</script>